// Copyright (c) 2019 Deere & Company

import t from 'tcomb';

const Location = t.struct({
    address1: t.maybe(t.String),
    address2: t.maybe(t.String),
    city: t.maybe(t.String),
    country: t.maybe(t.String),
    postalCode: t.maybe(t.String),
    state: t.maybe(t.String),
}, {
    name: 'Location',
    strict: true,
});

export const getDefaultState = () => new Location({
    address1: '',
    address2: '',
    city: '',
    country: '',
    postalCode: '',
    state: '',
});

export default Location;
